import * as React from 'react';
import { PartialEditUserFormRequest } from '../../../../../api/interfaces/User';
import { Alert, Box, Button, Switch, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { pushNotification } from '../../../../../components/PinnacleSnackbarProvider/PinnacleSnackbarProvider';
import { NotificationTypes } from '../../../../../components/PinnacleSnackbarProvider/PinnacleSnackbarProvider.types';
import { forgotPassword } from '../../../../../api/services/auth';
import { handleApiError } from '../../../../../utils/errorHandler';

interface AdditionalSettingsProps {
    formData: PartialEditUserFormRequest;
    onChange: (field: string, value: any) => void;
    email?: string;
    isTrial?: boolean;
    isActive?: boolean;
    disabled?: boolean;
}

const AdditionalSettings: React.FC<AdditionalSettingsProps> = ({
    formData,
    onChange,
    isTrial,
    isActive,
    disabled,
    email
}) => {
    const [isResetPasswordLoading, setIsResetPasswordLoading] = React.useState<boolean>(false);

    const handleResetPassword = async () => {
        setIsResetPasswordLoading(true);
        try {
            if (email) {
                const forgotPasswordResponse = await forgotPassword({ email });
                pushNotification({
                    details: forgotPasswordResponse.message,
                    type: NotificationTypes.Success,
                });
            }
        } catch (error) {
            handleApiError(error, {
                notify: (msg) => {
                    pushNotification({
                        details: msg,
                        type: NotificationTypes.Error,
                    });
                },
            });

        } finally {
            setIsResetPasswordLoading(false);
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <Box sx={{ pb: 1 }}>
                <Alert severity="info" icon={false} sx={{ backgroundColor: '#E5F8FE', color: '#26C6F9' }}>
                    <Typography variant="subtitle2">
                        This user is currently
                        <Box component="span" sx={{ fontWeight: 'bold' }}>{isActive ? ' ACTIVE ' : ' INACTIVE '}</Box>
                        and {isTrial && 'on'} a
                        <Box component="span" sx={{ fontWeight: 'bold' }}>{isTrial ? ' TRIAL ' : ' SUBSCRIBER '}</Box>
                        {isTrial && 'status'}.
                    </Typography>
                </Alert>
            </Box>

            <Box
                display="flex"
                alignItems="left"
                justifyContent="space-between"
                sx={{ width: "100%" }}
            >
                <Typography variant="body1" sx={{ color: '#333533', fontWeight: '600' }}>
                    Additional Settings
                </Typography>

                <Typography variant="body1" sx={{ color: '#A8A8A8', fontWeight: '600' }}>
                    3 of 3
                </Typography>
            </Box>


            {/* Active/Inactive Mode Toggle */}
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="body2" sx={{ color: '#818181' }}>
                    Set the status of user as <Box component="span" sx={{ fontWeight: 600 }}>“ACTIVE”</Box>?
                </Typography>
                <Switch
                    checked={formData.isActive}
                    onChange={(e) => onChange("isActive", e.target.checked)}
                    disabled={disabled}
                />
            </Box>

            <Box sx={{ alignSelf: 'flex-start' }}>
                <Button
                    variant="contained"
                    className="btn-white"
                    startIcon={<EmailIcon />}
                    onClick={handleResetPassword}
                    disabled={isResetPasswordLoading}
                    size="small"
                >
                    Email reset password
                </Button>
            </Box>

        </Box>
    );
};


export default AdditionalSettings;
